export default __webpack_public_path__ + "static/media/xlsx.f7ad5380.png";